import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-18e4369b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "mobile_register" }
const _hoisted_2 = { class: "title" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "Register For Business", -1))
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "dec" }, [
  /*#__PURE__*/_createTextVNode(" Free Up Your Mind with Sixliv AI - You and Your Patients Deserve More. "),
  /*#__PURE__*/_createElementVNode("p", null, "Personalised and Customised.")
], -1))
const _hoisted_6 = { class: "formWrapper" }
const _hoisted_7 = { class: "organization" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "register_title" }, "BUSINESS INFO", -1))
const _hoisted_9 = { class: "form" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Business Name", -1))
const _hoisted_11 = { class: "inputWrapper" }
const _hoisted_12 = { class: "form" }
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Category", -1))
const _hoisted_14 = { class: "inputWrapper" }
const _hoisted_15 = { class: "organization" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "register_title" }, "CONTACT INFO", -1))
const _hoisted_17 = { class: "formLine" }
const _hoisted_18 = { class: "formLineForm" }
const _hoisted_19 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "First Name", -1))
const _hoisted_20 = { class: "inputWrapper" }
const _hoisted_21 = { class: "formLineForm" }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "Last Name", -1))
const _hoisted_23 = { class: "inputWrapper" }
const _hoisted_24 = { class: "form" }
const _hoisted_25 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "label" }, "E-Mail", -1))
const _hoisted_26 = { class: "inputWrapper" }
const _hoisted_27 = {
  key: 0,
  class: "error"
}
const _hoisted_28 = { class: "form" }
const _hoisted_29 = { class: "verify_label" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Verify Code", -1))
const _hoisted_31 = {
  key: 1,
  class: "countdown"
}
const _hoisted_32 = { class: "inputWrapper" }
const _hoisted_33 = { class: "organization" }
const _hoisted_34 = { class: "join" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ArrowLeft = _resolveComponent("ArrowLeft")!
  const _component_el_icon = _resolveComponent("el-icon")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_button = _resolveComponent("el-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.store.handleCloseMobile && _ctx.store.handleCloseMobile(...args)))
      }, [
        _createVNode(_component_el_icon, null, {
          default: _withCtx(() => [
            _createVNode(_component_ArrowLeft)
          ]),
          _: 1
        })
      ]),
      _hoisted_3,
      _hoisted_4
    ]),
    _hoisted_5,
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", _hoisted_7, [
        _hoisted_8,
        _createElementVNode("div", _hoisted_9, [
          _hoisted_10,
          _createElementVNode("div", _hoisted_11, [
            _createVNode(_component_el_input, {
              modelValue: _ctx.formData.businessName,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.formData.businessName) = $event)),
              class: "input",
              placeholder: "Please input Business Name"
            }, null, 8, ["modelValue"])
          ])
        ]),
        _createElementVNode("div", _hoisted_12, [
          _hoisted_13,
          _createElementVNode("div", _hoisted_14, [
            _createVNode(_component_el_select, {
              modelValue: _ctx.formData.category,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.formData.category) = $event)),
              placeholder: "Please input category",
              class: "input"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectList, (item) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: item.id,
                    label: item.category,
                    value: item.id
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_15, [
        _hoisted_16,
        _createElementVNode("div", _hoisted_17, [
          _createElementVNode("div", _hoisted_18, [
            _hoisted_19,
            _createElementVNode("div", _hoisted_20, [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.firstName,
                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.formData.firstName) = $event)),
                class: "input",
                placeholder: "Please input firstName"
              }, null, 8, ["modelValue"])
            ])
          ]),
          _createElementVNode("div", _hoisted_21, [
            _hoisted_22,
            _createElementVNode("div", _hoisted_23, [
              _createVNode(_component_el_input, {
                modelValue: _ctx.formData.lastName,
                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.formData.lastName) = $event)),
                class: "input",
                placeholder: "Please input Last Name"
              }, null, 8, ["modelValue"])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _hoisted_25,
          _createElementVNode("div", _hoisted_26, [
            _createVNode(_component_el_input, {
              modelValue: _ctx.formData.email,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.formData.email) = $event)),
              class: "input",
              placeholder: "Please input email"
            }, null, 8, ["modelValue"])
          ]),
          (_ctx.isValidEmail)
            ? (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(_ctx.isValidEmail), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_28, [
          _createElementVNode("div", _hoisted_29, [
            _hoisted_30,
            (_ctx.countdown === 0)
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.handleSendCode && _ctx.handleSendCode(...args))),
                  class: "sent"
                }, "Sent"))
              : (_openBlock(), _createElementBlock("span", _hoisted_31, "countdown: " + _toDisplayString(_ctx.countdown), 1))
          ]),
          _createElementVNode("div", _hoisted_32, [
            _createVNode(_component_el_input, {
              modelValue: _ctx.formData.code,
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.formData.code) = $event)),
              class: "input",
              placeholder: "Please input Verify Code"
            }, null, 8, ["modelValue"])
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("div", _hoisted_34, [
          _createVNode(_component_el_button, {
            onClick: _ctx.handleSubmit,
            class: "button"
          }, {
            default: _withCtx(() => [
              _createTextVNode("Join Now")
            ]),
            _: 1
          }, 8, ["onClick"])
        ])
      ])
    ])
  ]))
}